import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
 
import { useActionState, useEffect } from "react";
import { deleteCategory } from "../actions";
import { deleteCharityIssue } from "../actions/charity-issue";
import toast from "react-hot-toast";
import { CharityIssue } from "../../../../models";

export function CreateButton() {
  return (
    <Link to={"/admin/charity-issue-categories/create"} className="contents">
      <Button className="mt-4">
        Create
        <Icon icon={PlusIcon} label="Create Feature" className="ml-1" />
      </Button>
    </Link>
  );
}


export function UpdateButton({ id }: { id: number }) {
  return (
    <Link to={`/admin/charity-issue-categories/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteButton({ id }: { id: number }) {
  const navigate = useNavigate();

  const deleteCategoryWithId = deleteCategory.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this category?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteCategoryWithId, {
    success: false,
    message: "",
  });

  useEffect(() => {
    if (state.success) {
      navigate(`/admin/charity-issue-categories?reload=${Date.now()}`, { replace: true });
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}
//--------------- charity issue buttons

export function CreateCharityIssueButton() {
  return (
    <Link to={"/admin/charity-issue-categories/create"} className="contents">
      <Button className="mt-4">
        Create
        <Icon icon={PlusIcon} label="Create Feature" className="ml-1" />
      </Button>
    </Link>
  );
}


export function UpdateCharityIssueButton({ id }: { id: number }) {
  return (
    <Link to={`/admin/charity-issue-categories/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteCharityIssueButton({ charityIssue }: { charityIssue: CharityIssue }) {
  const navigate = useNavigate();

  const deleteCategoryWithId = deleteCharityIssue.bind(null, charityIssue.id!);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this charity issue?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteCategoryWithId, {
    success: false,
    message: "",
  });

  useEffect(() => {
    if (state.success) {
      toast.success("Charity issue deleted successfully");
      navigate(`/admin/charity-issue-categories/edit/${charityIssue.charityIssueCategoryId}?reload=${Date.now()}`, { replace: true });
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}
